import { Breadcrumbs, Btn, H6 } from '../../AbstractElements';
import { PersonalDetails, FullName, Email, Password, RepeatPassword, PhoneNumber } from '../../../src/Constant/index';
import React, { Fragment, useState } from 'react';
import { Card, CardBody, Col, Form, FormGroup, Input, Label, Row } from 'reactstrap';
import HeaderCard from '../../myComponents/HeaderCard';
import { useSelector } from 'react-redux';
import axios from 'axios';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router';
import apiRequest from '../../utils/apiRequest';

const NewAdmin = () => {
  const token = useSelector((state) => state.auth.userToken);
  console.log("🚀 ~ NewAdmin ~ token:", token)

  const [loader, setLoader] = useState(false);

  // Define state for form inputs
  const [formData, setFormData] = useState({
    fullName: '',
    email: '',
    password: '',
    repeatPassword: '',
    phoneNumber: '',
    profileImage: null,  // Add this line
  });


  // Handle form input changes
  const handleChange = (e) => {
    if (e.target.name === 'profileImage') {
      setFormData({ ...formData, profileImage: e.target.files[0] });
    } else {
      setFormData({ ...formData, [e.target.name]: e.target.value });
    }
  };

  const navigate = useNavigate();

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoader(true);

    if (formData.password !== formData.repeatPassword) {
      alert("Passwords do not match!");
      setLoader(false);
      return;
    }

    const formDataToSend = new FormData();
    formDataToSend.append('userName', formData.fullName);
    formDataToSend.append('email', formData.email);
    formDataToSend.append('phoneNumber', formData.phoneNumber);
    formDataToSend.append('password', formData.password);
    if (formData.profileImage) {
      formDataToSend.append('profileImage', formData.profileImage);
    }

    try {
      const response = await apiRequest('post', `${process.env.REACT_APP_API_BASE_URL}/admin/create-sub-admin`, formDataToSend,
        token,
        { 'Content-Type': 'multipart/form-data' }
      );


      if (response.status === 201) {
        toast.success("Successfully created!");
        setLoader(false);
        setTimeout(() => {
          navigate(`/admin`);
        }, 2000);
      } else {
        toast.error("Failed to create admin.");
        setLoader(false);
      }
    } catch (error) {
      console.error("There was an error creating the admin!", error);
      setLoader(false);
    }
  };

  return (
    <Fragment>
      <Breadcrumbs mainTitle="Admin" parent="Dashboard" title="Create a new admin" />

      <Card>
        <CardBody>
          <Form onSubmit={handleSubmit}>
            <PersonalDetail handleChange={handleChange} formData={formData} />
            <CardBody className="text-end">
              <Btn
                attrBtn={{ color: "success", className: "m-r-15", type: "submit", disabled: loader }}
              >
                Create
              </Btn>
            </CardBody>
          </Form>
        </CardBody>
      </Card>
    </Fragment>
  );
};

export default NewAdmin;

const PersonalDetail = ({ handleChange, formData }) => {
  // eslint-disable-next-line
  const [multiple, setMultiple] = useState(false);

  return (
    <Fragment>
      <H6 attrH6={{ className: 'mb-4' }}>{PersonalDetails}</H6>
      <Form className="theme-form">
        <Row>
          <Col>
            <FormGroup>
              <Label htmlFor="fullName">{FullName}:<span className="font-danger">*</span></Label>
              <Input
                className="form-control"
                id="fullName"
                name="fullName"
                type="text"
                placeholder="Enter your full name"
                value={formData.fullName}
                onChange={handleChange}
              />
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col>
            <FormGroup>
              <Label htmlFor="email">{Email}:<span className="font-danger">*</span></Label>
              <Input
                className="form-control"
                id="email"
                name="email"
                type="email"
                placeholder="Enter email"
                value={formData.email}
                onChange={handleChange}
              />
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col>
            <FormGroup>
              <Label htmlFor="password">{Password}:<span className="font-danger">*</span></Label>
              <Input
                className="form-control"
                id="password"
                name="password"
                type="password"
                placeholder="Enter password"
                value={formData.password}
                onChange={handleChange}
              />
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col>
            <FormGroup>
              <Label htmlFor="repeatPassword">{RepeatPassword}:<span className="font-danger">*</span></Label>
              <Input
                className="form-control"
                id="repeatPassword"
                name="repeatPassword"
                type="password"
                placeholder="Repeat password"
                value={formData.repeatPassword}
                onChange={handleChange}
              />
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col>
            <FormGroup>
              <Label htmlFor="phoneNumber">{PhoneNumber}:</Label>
              <Input
                className="form-control"
                id="phoneNumber"
                name="phoneNumber"
                type="text"
                placeholder="Enter Phone no."
                value={formData.phoneNumber}
                onChange={handleChange}
              />
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col>
            <FormGroup>
              <Label htmlFor="profileImage">Profile Image:</Label>
              <Input
                className="form-control"
                id="profileImage"
                name="profileImage"
                type="file"
                onChange={handleChange}
              />
            </FormGroup>
          </Col>
        </Row>
      </Form>
    </Fragment>
  );
};
